var _path;
import * as React from "react";
function SvgSingleInsightBorderNegative(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.968 32.543A2.5 2.5 0 012.5 30.266V7A1.5 1.5 0 014 5.5h26A1.5 1.5 0 0131.5 7v23.266a2.5 2.5 0 01-1.468 2.277L17.62 38.17a1.5 1.5 0 01-1.238 0L3.968 32.543z"
  })));
}
export default SvgSingleInsightBorderNegative;